const get = function(action, onSuccess, onFail) {
	const request = new XMLHttpRequest();
	request.open('get', action);
	request.setRequestHeader('Content-type', 'application/json');

	request.onload = () => {
		if (request.status >= 200 && request.status < 300) {
			onSuccess(request);
		} else {
			onFail(request);
		}
	};
	request.onerror = () => {
		onFail(request);
	};
	request.ontimeout = () => {
		onFail(request);
	};

	request.send();
};

const post = function(action, values, onSuccess, onFail) {
	const request = new XMLHttpRequest();
	request.open('post', action);
	request.setRequestHeader('Content-type', 'application/json');

	request.onload = () => {
		if (request.status >= 200 && request.status < 300) {
			onSuccess(request);
		} else {
			onFail(request);
		}
	};
	request.onerror = () => {
		onFail(request);
	};
	request.ontimeout = () => {
		onFail(request);
	};

	request.send(JSON.stringify(values));
};

module.exports = {
	get,
	post
};
